// extracted by mini-css-extract-plugin
export default {"sidebar":"cohortsidebar_sidebar__xLWn0","sidebaritemList":"cohortsidebar_sidebaritemList__YDZux","active":"cohortsidebar_active__phZ+h"};